import { isGlobalProject } from 'config';
import { subYears } from 'date-fns';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  AdditionalDocumentsFormType,
  getAdditionalDocumentsSchema,
} from 'modules/client/common/forms/additionalDocumentsForm';
import { getCompanyBaseStateRegistrationSchema } from 'modules/client/common/forms/companyStateRegistrationForm';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { BaseActivityFormType, baseActivitySchema } from './baseActivityForm';
import { CompanyNameFormType, companyNameSchema } from './companyNameForm';
import {
  CompanyOrganizationalAndLegalFormFormType,
  getCompanyOrganizationalAndLegalFormSchema,
} from './companyOrganizationalAndLegalFormForm';
import {
  CompanyRegistrationAddressFormType,
  getCompanyRegistrationAddressSchema,
} from './companyRegistrationAddressForm';
import {
  CompanyResidentialAddressFormType,
  companyResidentialAddressSchema,
} from './companyResidentialAddressForm';
import {
  CompanyStateRegistrationFormType,
  getCompanyStateRegistrationSchema,
} from './companyStateRegistrationForm';
import {
  CompanyTaxResidencyFormType,
  companyTaxResidencySchema,
} from './companyTaxResidencyForm';
import {
  LegalClientHeadPositionFormType,
  getLegalClientHeadPositionFormSchema,
} from './legalClientHeadInfoForm';

export interface LegalClientLegalHeadFormType
  extends BaseActivityFormType,
    LegalClientHeadPositionFormType,
    CompanyNameFormType,
    CompanyTaxResidencyFormType,
    CompanyStateRegistrationFormType,
    CompanyRegistrationAddressFormType,
    CompanyResidentialAddressFormType,
    AdditionalDocumentsFormType,
    ReasonChangeFormType,
    CompanyOrganizationalAndLegalFormFormType {}

export const dateOfBirthMaxDate = subYears(new Date(), 18);
export const dateOfBirthMinDate = subYears(new Date(), 100);

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientLegalHeadFormType> => {
  const isGlobal = isGlobalProject();

  return object()
    .concat(baseActivitySchema)
    .concat(getLegalClientHeadPositionFormSchema(t))
    .concat(companyTaxResidencySchema)
    .concat(companyNameSchema)
    .concat(companyResidentialAddressSchema)
    .concat(getCompanyRegistrationAddressSchema())
    .concat(reasonChangeSchema)
    .concat(
      isGlobal
        ? getCompanyBaseStateRegistrationSchema(t)
        : getCompanyStateRegistrationSchema(t)
    )
    .concat(getAdditionalDocumentsSchema())
    .concat(
      applySchema(isGlobal, getCompanyOrganizationalAndLegalFormSchema(false))
    );
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientLegalHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientLegalHeadFormType>;
